import React from 'react';

import Heading from 'components/Heading';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import Row from 'components/Row';
import TargetByStudentIdHelpDialog from './TargetByStudentIdHelpDialog';
import Text from 'components/Text';
import TextWithGlyph from 'components/TextWithGlyph';

const prefixEvent = (suffix: string) => `announcements.target_by_student_id.upload_list.${suffix}`;

export default class TargetByStudentIdUploadPageSidebar extends React.Component<any, any> {
  render() {
    return (
      <div className="TargetByStudentIdUploadPage-sidebar">
        <Heading levelStyle="4" align="left">
          Upload a list of student numbers
        </Heading>
        <Text element="p" lineHeight="xlarge">
          Privately notify students and parents of chronic absences, lunch money balances, and more.
        </Text>
        <Row size="xsmall">
          <Text element="p" lineHeight="xlarge">
            Upload a CSV file containing the student numbers of the students you want to reach on
            Remind. Your CSV should contain one column with the header{' '}
            <Text element="code">student_number</Text> . You’ll see parent contacts in the next
            step.
          </Text>
        </Row>
        <Row size="small">
          <Link
            href="/assets/csv/student_number_list.csv"
            eventKey={prefixEvent('download_template.click')}
          >
            <TextWithGlyph glyph="download" glyphSize="small">
              Download a template
            </TextWithGlyph>
          </Link>
        </Row>
        <ModalTrigger modal={<TargetByStudentIdHelpDialog onRequestHide={() => {}} />}>
          <Link eventKey={prefixEvent('learn_to_format.click')}>
            <TextWithGlyph glyph="help" glyphSize="small">
              Learn how to format your CSV file
            </TextWithGlyph>
          </Link>
        </ModalTrigger>
      </div>
    );
  }
}
